import React from 'react';
import { formatQuantity } from '../../utils/format';
import { formatProductUnitType } from '../../utils/unitLabels';

export function OrderItemComponentsList({ components, tk, t }) {
  if (!components?.length) return null;

  return (
    <ul
      style={{
        margin: '5px 0 0 0',
        padding: 0,
        listStyle: 'none',
        fontSize: 11,
        color: tk.textSecondary,
        lineHeight: 1.45,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {components.map((comp, i) => {
        const qty = formatQuantity(comp.quantity_per_unit);
        const unit = formatProductUnitType(comp.product_unit_type, t);
        const qtyLabel = unit ? `${qty} ${unit}` : qty;
        return (
          <li
            key={comp.product_id || i}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: 6,
            }}
          >
            <span style={{ flexShrink: 0, lineHeight: 1.45 }} aria-hidden="true">
              •
            </span>
            <span style={{ flex: 1, minWidth: 0 }}>
              {qtyLabel} — {comp.product_name}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
